export const metricCards = [
  {
    id: 'exposed-devices',
    title: 'Exposed Devices',
    format: 'integer'
  },
  {
    id: 'website-visits',
    title: 'Website Visits',
    format: 'integer'
  },
  {
    id: 'conversion-rate',
    title: 'Conversion Rate',
    format: 'float',
    unit: '%'
  }
];
